import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export default function PageNavigation({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  onPageSelect,
  canGoPrevious,
  canGoNext,
  skipCover = false,
}) {
  const getPageLabel = (page) => {
    if (page === 0) return 'Front Cover';
    if (page === totalPages + 1) return 'Back Cover';
    return `Page ${page}`;
  };

  const handlePageSelect = (event) => {
    const value = event.target.value;
    if (value === 'front') {
      onPageSelect(0);
    } else if (value === 'back') {
      onPageSelect(totalPages + 1);
    } else {
      onPageSelect(parseInt(value, 10));
    }
  };

  // Build options based on skipCover flag
  const options = [];
  
  // Add front cover option if not skipping cover
  if (!skipCover) {
    options.push({ value: 'front', label: 'Front Cover' });
  }
  
  // Add content pages
  for (let i = 1; i <= totalPages; i++) {
    options.push({
      value: i,
      label: `Page ${i}`,
    });
  }
  
  // Add back cover option if not skipping cover
  if (!skipCover) {
    options.push({ value: 'back', label: 'Back Cover' });
  }

  // Calculate total pages count for display
  const displayedTotalPages = skipCover ? totalPages : totalPages + 2;

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-white rounded-lg shadow-sm">
      <button
        onClick={onPrevious}
        disabled={!canGoPrevious}
        className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronLeftIcon className="h-5 w-5 text-gray-500" />
      </button>

      <div className="flex items-center gap-2">
        <select
          value={
            currentPage === 0
              ? 'front'
              : currentPage === totalPages + 1
              ? 'back'
              : currentPage
          }
          onChange={handlePageSelect}
          className="block w-20 rounded-md border-gray-300 py-1.5 text-gray-900 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
        >
          {options.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        <span className="text-sm text-gray-500">of {displayedTotalPages} pages</span>
      </div>

      <button
        onClick={onNext}
        disabled={!canGoNext}
        className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronRightIcon className="h-5 w-5 text-gray-500" />
      </button>
    </div>
  );
}
